import React from "react"
import styled, {css} from "styled-components"
import { media } from "utils/Media"

const CopyBoxWrapper = styled.div`
  position: absolute;
  top: 0;
  height: 100%;
  right: 0;
  width: 100vw;
  z-index: 2;
  
 @media ${media.lg} {
    background: linear-gradient(0deg, #000 38%, rgba(0, 0, 0, 0) 100%);
    width: 346px;
  }
  
  @media ${media.xl} {
    min-width: 580px;
  }
  
  ${props => props.noBackground && css`
       background: none !important;
  `} 
    
`

CopyBoxWrapper.defaultProps = {
}

export default CopyBoxWrapper